<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors" :key=e.id>
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>


        <div class="row">

          <div class="col-12 col-md-12 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" id="basic-addon1">Başlık</span>
            </div>
            <input type="text" class="form-control" placeholder="Başlık" aria-label="Başlık" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="category.name" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  export default {
    data: function () {
      return {
        isEdit:false,
        categories:null,
        category:{
          category_id:"",
          name:null,
          url:null,
          is_active:1,
        },
        subCategories:null,
        disableParent:false,
        errors:[],
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js',
          height: 300
        }
      }
    },
    components: {
      Checkbox,
      Card
    },
    methods: {
      checkForm:function() {
        this.errors = [];
        if(!this.category.name) {this.errors.push("Başlık")};
        if(!this.errors.length) {
          this.save()
        }
      },
      save: function () {
        this.toggleLoader()
        if(this.isEdit){
          this.updateCategory()
        }else{
          this.saveCategory()
        }
      },
      saveCategory: function() {
        if(this.category.category_id === ""){
          if(this.subCategories !== null){
            this.subCategories = this.subCategories.split(/\n/g)
            var sub_categories = []
            for (var i = 0; i < this.subCategories.length; i++) {
              var subCategory = {
                name: this.subCategories[i],
                url: this.slugify(this.subCategories[i]) + '-' + Math.floor((Math.random() * (99999 - 0) + 0)),
                is_active: 1,
              }
              sub_categories.push(subCategory);
            }
            this.category.sub_categories = sub_categories;
          }
          this.category.url = this.slugify(this.category.name + '-' + Math.floor((Math.random() * (999 - 0) + 0)))
          this.category.category_type = "news"
          delete this.category.category_id
          this.$http.post('/api/categories/add', this.category).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              this.$router.push('/newcategories')
              this.toggleLoader()
            },
            e => {
            this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
            })
        }else{
          this.category.url = this.slugify(this.category.name + '-' + Math.floor((Math.random() * (999 - 0) + 0)))
          this.$http.post('/api/sub-categories/add', this.category).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              this.$router.push('/newcategories')
              this.toggleLoader()
            },
            e => {
            this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
            })
        }
      },
      updateCategory: function() {
        if(this.category.category_id === ""){
          if(this.subCategories !== null){
            this.subCategories = this.subCategories.split(/\n/g)
            var sub_categories = []
            for (var i = 0; i < this.subCategories.length; i++) {
              var subCategory = {
                name: this.subCategories[i],
                url: this.slugify(this.subCategories[i]) + '-' + Math.floor((Math.random() * (99999 - 0) + 0)),
                is_active: 1,
              }
              sub_categories.push(subCategory);
            }
            this.category.sub_categories = sub_categories;
          }
          this.category.url = this.slugify(this.category.name + '-' + Math.floor((Math.random() * (999 - 0) + 0)))
          delete this.category.category_id
          this.category.category_type = "news"
          this.$http.post('/api/categories/edit/' + this.$route.params.id, this.category).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              this.$router.push('/newcategories')
              this.toggleLoader()
            },
            e => {
            this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
            })
        }else{
          this.category.url = this.slugify(this.category.name + '-' + Math.floor((Math.random() * (999 - 0) + 0)))
          this.$http.post('/api/sub-categories/edit/' + this.$route.params.id, this.category).then(
            response => {
              this.notifier('top', 'right', 'success', 'Başarılı')
              this.$router.push('/newcategories')
              this.toggleLoader()
            },
            e => {
            this.toggleLoader()
                                                        if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
            })
        }
      },
      createUrl: function () {
        if(!isEdit){
          this.category.url = this.slugify(this.category.name)
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.toggleLoader()
        this.$http.get('/api/categories/allnews').then(
          response => {
            this.categories = response.body
            if(this.$route.params.id && this.$route.params.type){
              var controller = null
              if(parseInt(this.$route.params.type)){
                controller = 'sub-categories'
              }else{
                controller = 'categories'
                this.disableParent = true
              }
              this.$http.get('/api/' + controller + '/get-without-joins/' + this.$route.params.id).then(response => {
                this.isEdit = true
                this.category = response.body
                delete this.category.sub_categories
                if(controller === 'categories'){
                  this.category.category_id = ''
                }
                this.toggleLoader()
              }, response => {
                this.notifier(
                  'top',
                  'right',
                  'danger',
                  'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                  )
                this.toggleLoader()
              })
            }else{
              this.toggleLoader()
            }
          },
          er => {
            this.toggleLoader()
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            return
          })
      })
    }
  }
</script>
<style>
.input-group-text.is-valid{
  border-color: #28a745 !important;
}
.input-group-text{
  transition: 300ms;
}
.input-group-text.is-invalid{
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color:#fff;
}
.form-check-label{
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text{
  background-color: #e9ecef;
  border: 1px solid #ced4da; 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/NewcategoryModules/AddEdit.vue